<template>
  <div class="searcher-results gallery">
    <searcher-gallery-image v-for="(row, index) in rows" :key="`image-${index}`"
      :idColumn="idColumn"
      :externalUrlColumn="externalUrlColumn"
      :src="getRowColumnValue(row.requestIdValue, imageIdColumn)"
      :name="getRowColumnValue(row.requestIdValue, textIdColumn)"
      :withLangLegend="withLangLegend"
      @resultSelected="resultSelected(row.requestIdValue)"
    />
  </div>
</template>

<script>
import SearcherGalleryImage from '@/components/content/searcher/galleryImage'
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'searcher-gallery',
  props: [
    'idColumn',
    'codeColumn',
    'externalUrlColumn',
    'searcherHeader',
    'rows',
    'withLangLegend'
  ],
  data () {
    return {
      imageIdColumn: '',
      textIdColumn: ''
    }
  },
  components: {
    SearcherGalleryImage
  },
  beforeMount () {
    this.imageIdColumn = transport.methods.getSearcherAliasByType(this.searcherHeader, 'image')
    this.textIdColumn = transport.methods.getSearcherAliasByType(this.searcherHeader, 'text')
  },
  methods: {
    resultSelected (columns) {
      this.$emit('resultSelected', columns)
    },
    getRowColumnValue (id, columnId) {
      return transport.methods.getSearcherColumnValue(id, columnId)
    }
  }
}
</script>

<style lang="scss">
.searcher-results.gallery {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/gallery.vue